import axios from 'axios';
import type { AxiosResponse } from 'axios';
import type { ReCAPTCHAbleForm, ReCaptchaInterface, ReCAPTCHAToken, SiteKey, ValidationOptions } from './ReCaptcha.d';

export default class ReCaptcha implements ReCaptchaInterface
{
    validateUrl: string = `${window._siteConfig.SITESMART_SITE_URL}@/Captcha/?action=verifyReCaptcha`;
    forms: Array<ReCAPTCHAbleForm>;

    constructor(forms: Array<ReCAPTCHAbleForm>)
    {
        this.forms = forms;
        this.init();
    }

    init(): ReCaptcha
    {
        for (const k in this.forms) {

            const item = this.forms[k];
            if (item?.form && item?.siteKey) {

                this.validateKey(item.siteKey?.value).then(token => {

                    const token_input = document.createElement('input');
                    token_input.type = 'hidden';
                    token_input.name = 'google-recaptcha-token';
                    token_input.value = token;
                    item.form.appendChild(token_input);

                }).catch(e => {

                    console.error(e);
                    // item.form.submit();

                });

                item.form.addEventListener('submit', function(e) {

                    e.preventDefault();
                    item.form.submit();
                    return false;

                });
            }
        }

        return this;
    }

    validate(token: ReCAPTCHAToken, opts: ValidationOptions): ReCaptcha
    {
        axios.post(this.validateUrl, { token }).then((r: AxiosResponse) => {

            if (r?.data?.success) {

                opts.onSuccess(r);

            } else {

                opts.onFail(r);

            }

        });

        return this;
    }

    validateKey(siteKey: SiteKey): Promise<ReCAPTCHAToken>
    {
        return new Promise((resolve, reject) => {

            window.grecaptcha.ready(function() {

                try {

                    window.grecaptcha.execute(siteKey, { action: 'submit' })
                        .then(function(token: ReCAPTCHAToken) {

                            return resolve(token);

                        });

                } catch (e) {

                    return reject(e);

                }

            });

        });
    }
}
